import React, { useMemo } from "react";
import _ from "lodash";
import { useGetArticlesQuery, useGetBannersQuery } from "@api/apiV6";
import { useSelector } from "react-redux";
import { useFeatures } from "flagged";
import { useTranslation } from "react-i18next";
import { Div } from "@components/Generics.react";
import "@styles/components.scss";
import ArticleCard from "@components/ArticleCard.react";
import BannerCard from "@components/BannerCard.react";

export default function RecommendedArticles(props) {
    const { isSuccess } = useGetArticlesQuery();
    const { data: banners, isSuccess: bannerSuccess } = useGetBannersQuery();
    const articles = useSelector((state) => state.articles);
    // const user = useSelector((state) => state.auth.user);
    const features = useFeatures();
    const { t } = useTranslation("common");

    const recommended = useMemo(
        () =>
            isSuccess
                ? _.orderBy(
                    articles?.list,
                    ["priority", "updatedAt"],
                    ["desc", "desc"]
                ).slice(0, 10)
                : [],
        [articles, isSuccess]
    );

    // ========================= Render Function =================================
    return (
        <Div nopad fullht>
            <Div big padTop gutter bold uppercase>
                {t("components.recommended")}
            </Div>
            {features.general.noBanner && bannerSuccess ? (
                <Div autoOverflow padBottom ht="calc(100% - 45px)">
                    <BannerCard ads={banners} adsSuccess={bannerSuccess}/>
                </Div>
            ) : (isSuccess && (
                    <Div autoOverflow padBottom ht="calc(100% - 45px)">
                        {_.map(recommended, (article, idx) => {
                            return (
                                <ArticleCard
                                    key={`article-rightp-${article?._id}-${idx}`}
                                    article={article}
                                    feedStyle
                                />
                            );
                        })}
                    </Div>)
            )}
        </Div>
    );
}
